import React, { useRef, useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { API_BASE_URL, ENDPOINTS } from '../../config';

function MainHeader() {
  const [cookies, , removeCookie] = useCookies(["token"]);
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [user, setUser] = useState(null); // store user info
  const dropdownRef = useRef(null);

  const API_BASE = API_BASE_URL || "https://ai.holaai.in";

  const handleLogout = () => {
    removeCookie("token", { path: "/" });
    setUser(null);
    navigate("/login");
  };

  // Fetch current user once on mount
  useEffect(() => {
    const token = cookies.token;
    if (!token) return;

    fetch(`${API_BASE}/auth/me`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => (res.ok ? res.json() : null))
      .then(data => {
        if (data) setUser(data);
      })
      .catch(err => {
        console.error("Failed to load user:", err);
      });
  }, [cookies.token, API_BASE]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const displayName = user
    ? `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.email
    : "Guest";

  const profilePicture = user?.profile_picture || `${process.env.REACT_APP_BASE_URL}/assets/img/profile.jpg`;

  return (
    <div>
      <header className="header">
        <div className="header-left">
          <button className="sidebar-toggle d-lg-none" id="mobileSidebarToggle" onClick={() => window.__setSidebarVisible()}>
            <i className="fas fa-bars"></i>
          </button>
          <button className="sidebar-collapse-toggle d-none d-lg-block" onClick={() => window.__toggleSidebarCollapsed()}>
            <i className="fas fa-bars"></i>
          </button>
          <h1 className="page-title">
            <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/hola.png`} alt="logo" className="logo" />
          </h1>
        </div>

        <div className="header-right" ref={dropdownRef}>
          <div className="dropdown user-dropdown">
            <button className="btn user-menu-btn" onClick={() => setDropdownOpen((prev) => !prev)}>
              <div className="user-avatar-wrapper">
                <div className="user-avatar-fallback"><i className="fas fa-user"></i></div>
              </div>
              <div className="user-info-header d-none d-md-block">
                <div className="user-name-header">{displayName}</div>
              </div>
              <i className="fas fa-chevron-down dropdown-arrow"></i>
            </button>
            {dropdownOpen && (
              <div className="dropdown-menu dropdown-menu-end user-dropdown-menu show">
                <div className="dropdown-header">
                  <div className="user-profile-section">
                    <div className="user-avatar-large">
                      <img
                        src={profilePicture}
                        alt="User Avatar"
                        className="user-avatar-img-large"
                      />
                      <div className="user-avatar-fallback-large">
                        <i className="fas fa-user"></i>
                      </div>
                    </div>
                    <div className="user-details-dropdown">
                      <h6 className="user-name-dropdown">{displayName}</h6>
                      <p className="user-email">
                        {/* <Link to="#">info@gmail.com</Link> */}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="dropdown-divider"></div>

                {/* <Link className="dropdown-item enhanced-item" to="settings.html">
                            <div className="item-icon">
                              <i className="fas fa-cog"></i>
                            </div>
                            <div className="item-content">
                              <span className="item-title">Settings</span>
                              <span className="item-subtitle">Preferences and privacy</span>
                            </div>
                            <i className="fas fa-chevron-right item-arrow"></i>
                          </Link>
        
                          <div className="dropdown-divider"></div>
        
                          <Link className="dropdown-item enhanced-item help-item" to="#">
                            <div className="item-icon">
                              <i className="fas fa-question-circle"></i>
                            </div>
                            <div className="item-content">
                              <span className="item-title">Help & Support</span>
                              <span className="item-subtitle">Get assistance</span>
                            </div>
                            <i className="fas fa-external-link-alt item-arrow"></i>
                          </Link> */}

                <Link className="dropdown-item enhanced-item logout-item" onClick={handleLogout}>
                  <div className="item-icon">
                    <i className="fas fa-sign-out-alt"></i>
                  </div>
                  <div className="item-content">
                    <span className="item-title">Sign Out</span>
                    <span className="item-subtitle">Logout from account</span>
                  </div>
                  <i className="fas fa-chevron-right item-arrow"></i>
                </Link>
              </div>
            )}
          </div>
        </div>
      </header>
    </div>
  )
}

export default MainHeader